import { render, staticRenderFns } from "./DataItem.vue?vue&type=template&id=82588e2c&scoped=true&"
import script from "./DataItem.vue?vue&type=script&lang=js&"
export * from "./DataItem.vue?vue&type=script&lang=js&"
import style0 from "./DataItem.vue?vue&type=style&index=0&id=82588e2c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82588e2c",
  null
  
)

export default component.exports